import { Amplify } from 'aws-amplify'

// REACT_APP_NGROK_API_URL → Cognito clientMetadata.endpointOverride on auth calls (cognitoClientMetadata.js),
// not the REST API base URL (see legacy config-amplify.js).

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
        loginWith: {
          username: true,
          email: true,
          phone: true,
        },
      },
    },
  })
}
